const fixFormat = Intl.NumberFormat('es-US')
const columns = [
  {
    Header: "Fecha",
    accessor: "date",
    filterable: true,
    filterMethod: (filter, row) =>
      row.date.toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header: "Folio",
    accessor: "folio",
    filterable: true,
    filterMethod: (filter, row) =>
      String(row.folio).toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header: "# Embarque",
    accessor: "shipmentNumber",
    filterable: true,
    filterMethod: (filter, row) =>
      String(row.shipmentNumber).toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header: "PG",
    accessor: "pg",
    filterable: true,
    filterMethod: (filter, row) =>
      String(row.pg).toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header: "Kilos",
    accessor: "kilograms",
    filterable: true,
    Cell: props => props.value != null ? `${fixFormat.format(props.value)}kg` : null,
    filterMethod: (filter, row) =>
      String(row.kilograms).toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header: "Litros",
    accessor: "liters",
    filterable: true,
    Cell: props => props.value != null ? `${fixFormat.format(props.value)}lt` : null,
    filterMethod: (filter, row) =>
      String(row.liters).toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header: "Densidad",
    accessor: "density",
    filterable: true,
    Cell: props => props.value != null ? `${fixFormat.format(props.value)}` : null,
    filterMethod: (filter, row) =>
      String(row.density).toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header: "Origen",
    accessor: "origin",
    filterable: true,
    filterMethod: (filter, row) =>
      row.origin.toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header: "UUID Factura",
    accessor: "id",
    filterable: true,
    filterMethod: (filter, row) =>
      row.id.toLowerCase().includes(filter.value.toLowerCase()),
  },
];

export { columns };
